<template>
  <div class="dynamic-container">
    <headerIndex/>
    <div class="user">
      <h1 class="title SourceHanSansCN">{{ details.title }}</h1>
      <div class="user-info">
        <div class="user-logo" @click="authorPage(details.bid)">
          <el-image style="width: 50px; height: 50px;border-radius: 50%;" :src="details.user_avatar"/>
        </div>
        <div class="userTips" @click="authorPage(details.bid)">
          <div class="username SourceHanSansCN">{{ details.user_name }}</div>
          <div class="releaseTime">发布时间：{{ details.time }}</div>
          <div class="publishingPlatform">{{ details.identity_type_name }}</div>
        </div>
      </div>
    </div>
    <div class="dynamic-content">
      <div class="container">
        <div class="left">
          <!-- 文章文本 -->
          <div class="rich-content">
            <div class="html-box" v-html="details.content"></div>
            <div class="bottom" @click="report"><p>举报/反馈</p></div>
          </div>
          <!-- 发布评论 -->
          <div class="pushComment">
            <p class="push-title SourceHanSansCN">发表评论</p>
            <el-input type="textarea" :rows="5" placeholder="" v-model="textarea"></el-input>
            <el-popover placement="top-start" width="400" v-model="toggleEmoji">
              <div class="emojiList">
                <span v-for="row in emoji" :key="row" @click="addEmoji(row)">{{ row }}</span>
              </div>
              <div class="mask" @click="toggleEmoji = false"/>
              <i class="expression" slot="reference"/>
            </el-popover>
            <div class="u-flex u-row-between" style="padding-top: 10px">
              <div></div>
              <el-button type="primary" round @click="pinglun" style="float: right">发表</el-button>
            </div>
          </div>
          <commentList :commentArray="commentArray" :total="total" @reply="reply" @dianzan="getCommentList" @showMore="showMore"></commentList>
          <!-- 分页 -->
          <page :total="total" class="pagination" @currentPage="changePage"></page>
        </div>
        <recome-things :type="type"/>
      </div>
    </div>
    <home_footer/>
    <report ref="report" title="举报文章问题" type="1" :article_id="details.id"/>
    <hang/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import Hang from "@/components/Hang/Hang";
import report from "@/components/media/report";
import emoji from "@/common/emoji"
import commentList from "@/components/media/commentList";
import page from "@/components/page/pages";
import {articleInfo,commentNewList,commentAdd,policyInfo} from '@/api/interfaceApi'
import Home_footer from "@/components/footer/home_footer";
import RecomeThings from "@/components/recommend/recomeThings";
export default {
  components: {RecomeThings, Home_footer, headerIndex,Hang,report,commentList,page},
  name:'DynamicDetail',
  data() {
    return {
      cid: 0,
      id: 0,
      type: 1,
      details: {},
      reportShow: false,
      recommend: [], //相关文章
      textarea: "",
      commentArray: [], //评论列表
      saveArry: [], //保存的完整评论列表
      page: 1,
      total: 0,
      emoji,
      showEmoji: 'none',
      toggleEmoji: false,
    }
  },
  watch: {
    page(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getCommentList();
      }
    },
  },
  mounted() {
    this.getArticleInfo();
    this.getCommentList();
  },
  methods: {
    //获取详情
    getArticleInfo() {
      if (this.$route.query.method_type=='dynamic'){
        policyInfo({
          id: parseInt(this.id),
          type:parseInt(this.type),
          uid:this.cid!=0 && this.cid!=undefined ? this.cid : 0,
          cid:this.cid!=0 && this.cid!=undefined ? this.cid : 0,
        }).then(res=>{
          this.details = res.content;
          this.recommend = res.content.recommend;
        })
      }else {
        articleInfo({
          id: parseInt(this.id),
          type:parseInt(this.type),
          cid:this.cid!=0 && this.cid!=undefined ? this.cid : 0,
          uid:this.cid!=0 && this.cid!=undefined ? this.cid : 0
        }).then((res) => {
          if (res.code == 200) {
            this.details = res.content;
            this.recommend = res.content.recommend;
          }
        })
      }
    },
    //获取评论列表
    getCommentList() {
      commentNewList({
        aid: parseInt(this.id),
        page: this.page,
        pid: 0,
        type: parseInt(this.type),
        cid:this.cid!=0 && this.cid!=undefined ? this.cid : 0,
        uid:this.cid!=0 && this.cid!=undefined ? this.cid : 0
      }).then((res) => {
        if (res.code == 200) {
          this.commentArray = res.content.data;
          this.saveArry = JSON.parse(JSON.stringify(res.content.data));
          this.total = res.content.total;
          for (let item1 of this.commentArray) {
            if (item1.reply[0]) {
              item1.reply = item1.reply.slice(0, 2);
            }
          }
        }
      });
    },
    //打开举报页面
    report() {
      this.$refs.report.open();
    },
    // 点击评论
    pinglun() {
      let cid=JSON.parse(sessionStorage.getItem('loginData')).cid;
      if (!cid) {
        this.$message.error("请登录后操作");
      } else {
        if (this.textarea) {
          this.commentAddMethod();
        } else {
          this.$message.error("请输入内容");
        }
      }
    },
    // 网络请求 发布评论
    commentAddMethod(replyContent, replyId) {
      if (this.textarea.length > 600 || (replyContent && replyContent.length > 600)) {
        this.$message.error('字数不能超过600字')
        return
      }
      let obj = {
        aid: this.id, // 文章id
        pid: replyId || "", // 上级评论id(被回复的顶级评论id)
        replyId: "", // 被@的评论表id（回复里面@某条评论时传）
        type:this.type==2 ? 1 : this.type,// 类型（1：文章/视频，2：工作动态， 3：政策文件， 4：通知公告）
        content: replyContent || this.textarea, // 评论内容
        cid:this.cid!=0 && this.cid!=undefined ? this.cid : 0,
        uid:this.cid!=0 && this.cid!=undefined ? this.cid : 0
      };
      commentAdd(obj).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.textarea = "";
          this.getCommentList();
        }
      });
    },
    // 回复评论
    reply(obj) {
      this.commentAddMethod(obj.content, obj.id);
    },
    // 点击评论区的 展示更多
    showMore(obj) {
      this.commentArray[obj.index].reply = this.saveArry[obj.index].reply;
    },
    // 点击切换页码
    changePage(val) {
      this.page = val;
    },
    //在文章后面添加emoji表情
    addEmoji(emoji) {
      setTimeout(() => {
        this.textarea=this.textarea+emoji;
        this.toggleEmoji=false;
      }, 100);
    },
    /*查看用户信息*/
    authorPage(bid){
      let routeData = this.$router.resolve({
        name: "userInfo",
        query:{bid:bid},
        path: '/userInfo/index',
      });
      window.open(routeData.href, '_blank')
    },
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.cid = sessionStorage.getItem('loginData')!='' &&  sessionStorage.getItem('loginData')!=null && sessionStorage.getItem('loginData')!=undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
};
</script>

<style scoped lang="scss">
.dynamic-container {
  background: #F1F1F1;
  .user {
    padding: 0 18%;
    min-width: 76rem;
    background: #F1F1F1;
    .title {
      font-size: 36px;
      color: #333333;
      padding-top: 60px;
      margin-block-start: 0px;
      margin-block-end: 0px;
    }

    .user-info {
      min-height: 90px;

      .user-logo {
        width: 38pt;
        height: 38pt;
        float: left;
        margin-top: 20px;
      }

      .userTips {
        float: left;
        padding-left: 10pt;
        margin-top: 20px;

        .username {
          font-size: 18px;
          font-weight: 600;
          color: #555555;
        }

        .releaseTime {
          float: left;
          font-size: 14px;
          padding-top: 5pt;
        }

        .publishingPlatform {
          float: left;
          font-size: 14px;
          margin-left: 10pt;
          padding-top: 5pt;
        }
      }
    }
  }
  .dynamic-content {
    min-height: 100vh;
    background-color: #fff;
    min-width: 76rem;
    padding:0px 18% 30px;
    .container {
      display: flex;
      align-items: flex-start;
      .left {
        width: 100%;
        box-sizing: border-box;
        padding-right: 2%;
        padding-top: 30px;
        margin-right: 2%;
        border-right: 1px solid #DDDDDD;
        .rich-content {
          position: relative;
          padding-bottom: 20px;
          border-bottom: 1px solid #ddd;
          .html-box{
            padding-bottom: 20px;
          }
          &::after {
            position: absolute;
            content: "";
            width: 3%;
            display: block;
            height: 1px;
            background: #ddd;
            right: -3%;
            bottom: -1px;
          }
          .bottom {
            font-size: 16px;
            cursor: pointer;
            display: flex;
            justify-content: right;
            width: 100%;
          }
        }
      }
      .relation {
        flex: 1;
        padding-top: 40px;
        position: sticky;
        top: 0;
        .title {
          font-size: 22px;
          padding-bottom: 20px;
        }
        .item {
          margin-bottom: 40px;
          cursor: pointer;
          .name {
            font-size: 16px;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .pushComment {
    .push-title {
      font-size: 20px;
      margin-bottom: 20px;
    }
  }
  .author {
    &:hover {
      color: #fe273b;
    }
  }
  .chat_total {
    font-size: 20px;
    font-family: 'SourceHanSansCN';
    color: #333333;
  }
}
</style>
<style scoped>
.html-box >>> img {
  max-width: 100% !important;
  margin: 20px -20px;
}

.html-box >>> p {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
}

.pushComment >>> .el-textarea__inner {
  background-color: #F1F1F1;
  resize: none;
  border-radius: 12px;
  font-size: 16px;
  color: #333333;
}
.pagination >>> .titel {
  display: none;
}
.img_detail {
  margin-top: 10px;
}
.pushComment >>> .el-button--primary {
  color: #FFF;
  background-color: #0067DD;
  border-color: #0067DD;
}
.emojiList {
  width: 520px;
  height: 300px;
  overflow: auto;
  background-color: white;
  text-align: justify;
  align-items: center;
  flex-wrap: wrap;
  z-index: 9999;
  padding: 0 10px 10px 0px;
}

.emojiList >>> span {
  font-size: 20px;
  cursor: pointer;
  width: 58px;
  margin: 10px 5px;
}
.expression{
  background: url("~@/assets/img/biaoqing.png") no-repeat;
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  float: left;
  margin-top: 15px;
}
</style>